import React, { useState } from "react";
import { Typography } from "@mui/material";
import {
  ICredentialsSouthpostErrors,
  ICredentialsSouthpostPayload,
  ICredentialsStep,
} from "../../../interfaces/configuration";
import { IValidation } from "../../../interfaces/form";
import { ERRORS_MESSAGES } from "../../../utils/constants";
import { validateInputs } from "../../../utils/inputValidations";
import CredentialsSouthpost from "../../forms/CredentialsSouthpost";
import ConfirmChangesCredentials from "../../configuration/ConfirmChangesCredentials";
import GenericForm from "../../GenericForm";
import GenericAlert from "../../GenericAlert";

const { tokenRequired, branchCodeRequired } = ERRORS_MESSAGES;

const formValidations: IValidation[] = [
  {
    id: "api_token",
    type: "required",
    message: tokenRequired,
  },
  {
    id: "branch_code",
    type: "required",
    message: branchCodeRequired,
  },
];

const SouthpostCredentials = ({
  handleCancel,
  loading,
  alert,
  carrier,
  handleSubmitCarriers,
}: ICredentialsStep) => {
  const [credentials, setCredentials] = useState(
    {} as ICredentialsSouthpostPayload
  );
  const [errors, setErrors] = useState({} as ICredentialsSouthpostErrors);

  const handleSubmit = () => {
    const inputErrors = validateInputs(credentials, formValidations);
    setErrors(inputErrors);
    if (Object.keys(inputErrors).length === 0) {
      handleSubmitCarriers([
        {
          ...carrier,
          credentials,
        },
      ]);
    }
  };

  return (
    <>
      <Typography className="f-s-24 m-b-20">Credenciales de SOUTHPOST</Typography>
      {alert.showAlert && <GenericAlert alert={alert} />}
      <GenericForm onSubmit={handleSubmit}>
        <CredentialsSouthpost
          values={credentials}
          setValues={setCredentials}
          errors={errors}
        />
      </GenericForm>
      <ConfirmChangesCredentials
        onClose={handleCancel}
        handleSubmit={handleSubmit}
        disabled={loading}
        backText="Cambiar operador"
        confirmText="Finalizar"
      />
    </>
  );
};

export default SouthpostCredentials;
